import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  "stroke-width": "2.5",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  class: "lucide lucide-italic w-4 h-4"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("line", {
  x1: "19",
  x2: "10",
  y1: "4",
  y2: "4"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("line", {
  x1: "14",
  x2: "5",
  y1: "20",
  y2: "20"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("line", {
  x1: "15",
  x2: "9",
  y1: "4",
  y2: "20"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }